/**
 * IMPORTS
 */
import * as commands from 'src/aggregates/tags/commands';
import * as handlers from 'src/aggregates/tags/handlers';
import {execute} from 'src/aggregates/execute';


/**
 * TYPES
 */
import {IUpdateTagPatch} from 'src/aggregates/tags/mutations.d';


/**
 * CODE
 */

/**
 * I am an API to create a tag
 *
 * :param name: tag name
 * :param color: tag color
 *
 * :returns promise with nothing
 */
async function create (name: string, color: string): Promise<void>
{
    await execute(commands.create(name, color), handlers.create);
}


/**
 * I am an API to load tags.
 *
 * :returns: promise with nothing
 */
async function load (): Promise<void>
{
    await execute(commands.load(), handlers.load);
}


/**
 * I am an API to reset tags errors.
 *
 * :returns: promise with nothing
 */
async function resetError (): Promise<void>
{
    await execute(commands.resetError(), handlers.resetError);
}


/**
 * I am an API to update a tag.
 *
 * :param id: tag id
 * :param name: tag name to be updated for
 * :param company: tag company to be updated for
 *
 * :returns: promise with nothing
 */
async function update(
    id: number,
    tag: IUpdateTagPatch,
    color: string,
): Promise<void>
{
    await execute(commands.update(id, tag, color), handlers.update);
}


/**
* EXPORTS
*/
export {
    create,
    load,
    resetError,
    update,
};
